// Shared state for the icon-card accordion: one tab is always open. Selecting a
// tab opens it (closing the previous); there is no toggle-off. Card widths come
// from CSS (--icat-count, set server-side), so all this needs to track is which
// tab is open. `ready` gates the width transition until after the first tab has
// claimed the open slot, so the default-open card doesn't animate on load.
window.IconCardAccordion = () => {
	return {
		current: null,
		ready: false,

		init() {
			this.$nextTick(() => {
				this.ready = true;
			});
		},

		select(id) {
			this.current = id;
		},

		isOpen(id) {
			return this.current === id;
		},

		// Called from each tab's x-init; the first one (current still null) becomes
		// the default-open card.
		openFirst(id) {
			if (this.current === null) this.current = id;
		},
	};
};
